import trialCouponEn from './trial-coupon/en.json';
import trialCouponZhHant from './trial-coupon/zh-Hant.json';
import trialCouponVi from './trial-coupon/vi.json';
import trialCouponTh from './trial-coupon/th.json';

export default {
  en: trialCouponEn,
  'zh-Hant': trialCouponZhHant,
  vi: trialCouponVi,
  th: trialCouponTh,
};
